import { postApi } from "./api_instance";

export const verifyOtp = async ({ code, email, userType }, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: "/api/user/signup/verifyotp",
      dispatch,
      data: { OTP: code, email, user_type: userType },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
